import { render, staticRenderFns } from "./ManageFaviconView.vue?vue&type=template&id=080c3b3b&"
import script from "./ManageFaviconView.vue?vue&type=script&lang=js&"
export * from "./ManageFaviconView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports